'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.stringify = stringify;
exports.hyphenize = hyphenize;
exports.parse = parse;
exports.toArray = toArray;
exports.validate = validate;
exports.convertSearchStateToDestinationString = convertSearchStateToDestinationString;
exports.getSearchText = getSearchText;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var KEYS = ['country', 'subdivision', 'city', 'spot'];

function stringify(item) {
  return KEYS.map(function (key) {
    return (item[key] || '').replace(/_/g, ' ');
  }).filter(function (item) {
    return item;
  }).reverse().join(', ');
}

/**
 * Convert the form destination value to URL formatted string
 * @param  {[type]} args [description]
 * @return {[type]}      [description]
 */
function hyphenize(args) {
  var string = '';
  if (_lodash2.default.isString(args)) {
    string = args;
  } else {
    string = stringify(args);
  }
  return string.replace(/\s/g, '_').split(',_').reverse().join('-');
}

/**
 * Covert the URL formatted destination string to an object
 * @param  {[type]} string [description]
 * @return {[type]}        [description]
 */
function parse(string) {
  var item = {
    country: '',
    subdivision: '',
    city: '',
    spot: ''
  };
  string.split('-').forEach(function (value, index) {
    item[KEYS[index]] = value.replace(/_/g, ' ')
    // TODO: After API has been change to accept " Prefecture", remove logic below.
    .replace(' Prefecture', '_Prefecture');
  });
  return item;
}

function toArray(hyphenized) {
  return hyphenized.split('-').map(function (value) {
    return value.replace(/_/g, ' ');
  });
}

function validate(hyphenized, list) {
  var array = toArray(hyphenized);
  var isValid = _lodash2.default.find(list, { 3: array.pop(), 5: array.reverse() });
  return isValid !== undefined;
}

/**
 * Convert the country, subdivision, city, spot values to a destination string which is displayed in the search box
 * @param  {[type]} search [description]
 * @return {[type]}        [description]
 */
function convertSearchStateToDestinationString(_ref) {
  var country = _ref.country,
      subdivision = _ref.subdivision,
      city = _ref.city,
      spot = _ref.spot;

  return [spot, city, subdivision, country].filter(function (item) {
    return item;
  }).join(', ').replace(/_/g, ' ');
}

function getSearchText(list, _ref2) {
  var country = _ref2.country,
      subdivision = _ref2.subdivision,
      city = _ref2.city,
      spot = _ref2.spot;

  var targets = _lodash2.default.compact([country, subdivision.replace(/_/g, ' '), city.replace(/_/g, ' '), spot.replace(/_/g, ' ')]).reverse();

  var place = targets.shift();
  var matched = _lodash2.default.find(list, function (item) {
    return item && item[6] === place && _lodash2.default.isEqual(item[7], targets);
  });
  return matched ? [matched[3]].concat(matched[5]).join(', ') : '';
}


//////////////////
// WEBPACK FOOTER
// ./src/helpers/destination-parser.js
// module id = 279
// module chunks = 0